import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const InquiryModalContext = createContext(null);

export function InquiryModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openInquiry = useCallback(() => setIsOpen(true), []);
  const closeInquiry = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, openInquiry, closeInquiry }), [isOpen, openInquiry, closeInquiry]);

  return <InquiryModalContext.Provider value={value}>{children}</InquiryModalContext.Provider>;
}

export function useInquiryModal() {
  const ctx = useContext(InquiryModalContext);
  if (!ctx) {
    throw new Error("useInquiryModal must be used within an InquiryModalProvider");
  }
  return ctx;
}
